import React, { createContext, useContext, useState, useCallback } from "react";
import { getCookie } from "../../../utils/cookieUtils";

const SavedStrategiesContext = createContext();

export const SavedStrategiesProvider = ({ children }) => {
  const [savedStrategies, setSavedStrategies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchSavedStrategies = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const client_id = getCookie("client_id");

      if (!client_id) {
        throw new Error("Client ID not found in localStorage");
      }

      const response = await fetch(
        "https://zp4749ggcf.execute-api.ap-south-1.amazonaws.com/default/getSavedStrategies",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            user_id: client_id,
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setSavedStrategies(data.strategies || []);
      return data.strategies || [];
    } catch (err) {
      console.error("Error fetching saved strategies:", err);
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const refreshSavedStrategies = useCallback(() => {
    return fetchSavedStrategies();
  }, [fetchSavedStrategies]);

  const value = {
    savedStrategies,
    setSavedStrategies,
    loading,
    error,
    fetchSavedStrategies,
    refreshSavedStrategies,
  };

  return (
    <SavedStrategiesContext.Provider value={value}>
      {children}
    </SavedStrategiesContext.Provider>
  );
};

export const useSavedStrategies = () => {
  const context = useContext(SavedStrategiesContext);
  if (!context) {
    throw new Error(
      "useSavedStrategies must be used within a SavedStrategiesProvider"
    );
  }
  return context;
};
